import type { AppDefinition } from '../../../../types/apps';

const icd10Definition: AppDefinition = {
  appId: 'phys-icd10',
  name: 'ICD-10 Lookup',
  version: '1.0.0',
  description: 'ICD-10-CM code search with specificity analysis — powered by NLM Clinical Tables.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'phys-icd10',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'MagnifyingGlass',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-icd10',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['physician_widget'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
  hidden: true,
};

export default icd10Definition;
